import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import i18n from "@/i18n";

import { VoorBureausPage } from "@/pages/voor-bureaus";

export const Route = createFileRoute("/voor-bureaus")({
  head: () => {
    const t = i18n.getFixedT("nl", "seo");
    return pageHead({
      lang: "nl",
      pathWithoutLang: "/voor-bureaus",
      title: t("voor-bureaus.title") as unknown as string,
      description: t("voor-bureaus.description") as unknown as string,
    });
  },
  component: VoorBureausPage,
});
